<template>
	<Row>
		<Col :span="24">
			<Table :columns="columns" :data-source="rtcmMessagesDisplay" :pagination="false" />
		</Col>
	</Row>
</template>

<script>
import { toRef, ref, watch, computed } from 'vue';

import { useI18n } from 'vue-i18n';

import { Row, Col, Table } from 'ant-design-vue';

import { showErrorMessage } from '@/components/common/errorMessage';

import Api from '@/api/Api';
import Consts from '@/api/Consts';


export default {
	components: { Row, Col, Table },
	props: ['baseStationId'],
	setup(props) {
		const { t } = useI18n();
		const baseStationId = toRef(props, 'baseStationId');
		const rtcmMessages = ref([]);
		const requestData = () => {
			const value = baseStationId.value;
			if (value > 0) {
				Api.baseStationNetInfoGet(value, response => {
					if (response.status === 'ok') {
						rtcmMessages.value = response.rtcm_messages;
					} else {
						showErrorMessage(response.errors);
						rtcmMessages.value = [];
					}
				});
			}
		}
		watch(baseStationId, requestData);
		requestData();
		const rtcmMessagesDisplay = computed(() => rtcmMessages.value.map(item => ({
			index: item.index,
			label: t(`net-info-table.rtcm-messages.description.${item.label}`, t('net-info-table.rtcm-messages.description.unknown')),
		})));
		return {
			rtcmMessagesDisplay,
			columns: Consts.rtcmMessagesTableColumnsComp,
		};
	},
}
</script>
